import EmailSendLimit from './EmailSendLimit';

export default EmailSendLimit;
